import React, { useEffect, useState } from 'react';
import { fetchTopPosts } from '../../services/Api/DrugInfo';
import _ from 'lodash';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
const BlogPosts = ({
  isFromLemonaid = false,
  heading = '',
  hideSubText = false,
  subText = '',
  postTags,
  blogWidth = 'defaultWidth'
}) => {
  const [blogData, setBlogData] = useState([]);
  const { t } = useTranslation();
  useEffect(() => {
    fetchTopPosts(isFromLemonaid, postTags).then(res => {
      if (res) setBlogData(res.posts);
    });
  }, []);
  const renderRelatedArticles = () => {
    let relatedArticles = [];
    if (!_.isEmpty(blogData)) {
      relatedArticles = blogData.map((post, id) => {
        let img =
          post?.thumbnail_images?.medium?.url ||
          post?.thumbnailImages?.medium?.url;
        return (
          <a className="post" key={id} href={post?.url}>
            <LazyLoadImage className="post-img" src={img} alt="" />
            <LazyLoadImage className="post-img-Mobile" src={img} alt="" />
            <div className="post-details">
              <span className="link">
                <h3 dangerouslySetInnerHTML={{ __html: post?.title }}></h3>
              </span>
            </div>
          </a>
        );
      });
    }
    return relatedArticles;
  };
  const articles = renderRelatedArticles();
  return (
    <section className={`newBlogPosts ${blogWidth}`}>
      <section className="related-posts">
        {!_.isEmpty(articles) && (
          <>
            {!_.isEmpty(heading) ? (
              <h2 className="blogpPostHeading">
                {heading ? heading : t('ToppostsfromTheCheckup')}
                <span className={hideSubText ? 'hide' : ''}>
                  {subText ? subText : t('a blog by SingleCare')}
                </span>
              </h2>
            ) : (
              <h2 className="blogHeadingNew">
                Top posts from <span className="pinkText">The Checkup</span>
                <span className="subHeading">a blog by SingleCare</span>
              </h2>
            )}
          </>
        )}
        <div className="post-container">
          <div className="post-flexGrid">{articles}</div>
        </div>
        {!_.isEmpty(blogData) && _.isEmpty(postTags) && (
          <div className="action-btn">
            <a className="all-blog-link" href="/blog/">
              {t('Check out our blog')}
              <LazyLoadImage
                src="/content/images/arrows/arrow-right.svg"
                alt=""
                width="24"
                height="17"
              />
            </a>
            <a className="blogLinkNew" href="/blog/">
              Check it out
            </a>
          </div>
        )}
      </section>
    </section>
  );
};

export default BlogPosts;
